import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { Update } from '../../../../hooks/useLoadSurvey'
import { Survey } from '../../../../../types/Survey/Survey'
import getTemplateElement, { getPrebuildTemplateElement } from './getTemplateElement'
import { PrebuildType, Type } from '../../../../../types/Survey/Element'
import Accordion from '../../../../UI/Accordion/Accordion'

enum SectionType {
  PREBUILD = 'PREBUILD',
  CUSTOM = 'CUSTOM',
}

const AddElement: React.FC<{ survey: Survey; update: Update }> = ({ survey, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const add = (type: Type | PrebuildType) => () => {
    let element = null
    if (!!PrebuildType[type]) {
      element = getPrebuildTemplateElement(type as PrebuildType)
    } else {
      element = getTemplateElement(type as Type)
    }
    if (element) {
      update({ ...survey, elements: [...survey.elements, element] })
    } else {
      alert(`"${type}" not implemented yet.`)
    }
  }

  const getElement = (type: Type | PrebuildType) => {
    return (
      <div key={type} className="text-white border-t border-cyan border-opacity-10 px-5 py-3 cursor-pointer hover:underline" onClick={add(type)}>
        {t.survey.elements.types[type]}
      </div>
    )
  }

  const getElementSections = () => {
    const prebuildElements = [
      PrebuildType.ANWESENHEIT,
      PrebuildType.ARBEITSTAG,
      PrebuildType.EINZELARBEIT,
      PrebuildType.MEETING_GROESSE_BESPRECHUNG,
      PrebuildType.MEETING_GROESSE_COWORKING,
      PrebuildType.TELEPHONE_MORE_THEN,
      Type.ORGANIZATION_UNIT_COOPERATION_SELECTION,
    ].map((type) => getElement(type))
    const customElements = [
      Type.STATIC_TEXT,
      Type.SLIDER_GROUP,
      Type.SLIDER,
      Type.SELECTION,
      Type.DYNAMIC_TEXT,
      Type.SLIDER_DROPDOWN,
      Type.SLIDER_DROPDOWN_GROUP,
      Type.BOOLEAN_SELECTION,
    ].map((type) => getElement(type))

    return [
      {
        key: SectionType.PREBUILD,
        title: t.survey.configuration.section.prebuild,
        content: <div>{prebuildElements}</div>,
      },
      {
        key: SectionType.CUSTOM,
        title: t.survey.configuration.section.custom,
        content: <div>{customElements}</div>,
      },
    ]
  }

  return (
    <div className="flex">
      <div className="w-full flex flex-col">
        <Accordion className="mt-3" items={getElementSections()} initOpenIndex={SectionType.PREBUILD} />
      </div>
    </div>
  )
}

export default AddElement
